import React from "react";
import LegalitiesPolicyContainer from "modules/Authentication/containers/LegalitiesPolicyContainer/LegalitiesPolicyContainer";

type Props = {};

const LegalitiesPolicy = (props: Props) => {
  return <LegalitiesPolicyContainer />;
};

export default LegalitiesPolicy;
